export enum LoginMethod {
  PHONE = 'phone',
  CODE = 'code',
  EMAIL = 'email'
}

export enum LoginStep {
  PHONE = 'BY_PHONE',
  EMAIL = 'BY_EMAIL',
  CODE = 'CODE',
  ORDER = 'ORDER',
  SKIP = 'SKIP',
  FORGOT = 'FORGOT'
}

export enum InputStatus {
  BLANK = 'BLANK',
  WAIT_TO_CHECK = 'WAIT_TO_CHECK',
  NEED_CHECK = 'NEED_CHECK',
  VALID_PHONE = 'VALID_PHONE',
  VALID_EMAIL = 'VALID_EMAIL',
  INVALID_PHONE = 'INVALID_PHONE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  CANT_DETECT = 'CANT_DETECT',
  CANT_FIND_PHONE = 'CANT_FIND_PHONE',
  CANT_FIND_EMAIL = 'CANT_FIND_EMAIL'
}

export enum LoginApiMethod {
  EMAIL_ORDER = 'EMAIL_ORDER',
  EMAIL_CODE = 'EMAIL_CODE',
  PHONE_ORDER = 'PHONE_ORDER',
  PHONE_CODE = 'PHONE_CODE',
  GET_CODE_EMAIL = 'GET_CODE_EMAIL',
  GET_CODE_PHONE = 'GET_CODE_PHONE'
}
